module.exports = __webpack_public_path__ + "img/vertical_6_6_8011.783aee24.png";